import React from 'react';
import { ReactComponent as Close } from "../../assets/icons/x.svg";
import {ReactComponent as Success} from "../../assets/icons/Seccess.svg"
import { useScreenTransition } from '../../Hooks/useScreenTransition';
import './AccountCreated.css';
import { useCheckoutT } from '../../i18n/checkout';

export default function AccountCreated({closeAccountCreated,accoutTypeSelected}) {
  const { transitionTo } = useScreenTransition();
  // English everywhere but the checkout (see i18n/checkout).
  const { t } = useCheckoutT();

  if(accoutTypeSelected === "business") {
    return <></>;
  }

  return (
    <div className='accountCreatedForm'>
        <div className='accountCreatedFormHeader'>
            <h2 className='accountCreatedFormTitle'>{t("account.createdTitle")}</h2>
            <Close className='signInFormIcon' onClick={()=>closeAccountCreated()}/>
        </div>
        <Success className='accountCreatedSuceessIcon'/>
        <span className='accountCreatedFormSpan'>{t("account.createdText", { type: accoutTypeSelected })}</span>
        <button className='accountCreatedFormGotoAccount' onClick={() => transitionTo('/account/orders')}>{t("account.goToAccount")}</button>
    </div>
  )
}
